import { createSelector } from 'reselect'

const getListingIds = (state: any) =>
  state.entities && state.entities.dealerListings ? state.entities.dealerListings.allIds : []

export default createSelector(getListingIds, (ids) => ids)
